import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router";
import { PageError } from "./layouts/PageError";
import { PageLayout } from "./layouts/PageLayout";
import PageNotFound from "./layouts/PageNotFound";

const ImageManagement = lazy(() => import("../pages/image-management/ImageManagement"));
const ManageVersion = lazy(() => import("../pages/image-management/ManageVersion"));
const FleetStatus = lazy(() => import("../pages/fleet-status/FleetStatus"));
const TaskManagement = lazy(() => import("../pages/task-management/TaskManagement"));
const ViewTaskDetails = lazy(() => import("../pages/task-management/ViewTaskDetails"));
const CreateTaskPage = lazy(() => import("../pages/task-management/CreateTaskPage"));
const QubeAcs = lazy(() => import("../pages/appliances/QubeAcs"));
const UpdateAcs = lazy(() => import("../pages/appliances/UpdateAcs"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <PageLayout />,
    errorElement: <PageError />,
    children: [
      { index: true, element: <Navigate to="/fleet" replace /> },
      {
        path: "/fleet",
        children: [
          { index: true, element: <Navigate to="status" replace /> },
          { path: "status", element: <FleetStatus /> },
          {
            path: "task-management",
            children: [
              { index: true, element: <TaskManagement /> },
              { path: ":taskId", element: <ViewTaskDetails /> },
              { path: "create", element: <CreateTaskPage /> },
            ],
          },
          {
            path: "image-management",
            children: [
              { index: true, element: <ImageManagement /> },
              { path: ":appId", element: <ManageVersion /> },
            ],
          },
        ],
      },
      {
        path: "/appliance",
        children: [
          {
            path: "acs",
            children: [
              { index: true, element: <QubeAcs /> },
              { path: ":acsId", element: <UpdateAcs /> },
            ],
          },
        ],
      },
      { path: "*", element: <PageNotFound /> },
    ],
  },
]);
